import {combineReducers} from 'redux'
import types from 'actions/types'

export const isVisible = (state = false, action) => {
  switch (action.type) {
    case types.SHOW_ADD_PURCHASE_ORDER_DIALOG:
      return true
    case types.HIDE_ADD_PURCHASE_ORDER_DIALOG:
      return false
    default:
      return state
  }
}

export const copyFromId = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_PURCHASE_ORDER_DIALOG:
      return action.copyFromId
    case types.HIDE_ADD_PURCHASE_ORDER_DIALOG:
      return null
    default:
      return state
  }
}

export const purchaseOrder = (state = null, action) => {
  switch (action.type) {
    case types.SHOW_ADD_PURCHASE_ORDER_DIALOG:
      return action.purchaseOrder
    case types.HIDE_ADD_PURCHASE_ORDER_DIALOG:
      return null
    default:
      return state
  }
}

export default combineReducers({
  isVisible,
  copyFromId,
  purchaseOrder,
})
